import React, {
    PropsWithChildren, useEffect, useLayoutEffect
} from 'react';
import { useDispatch } from 'react-redux';

import {
    useSelectorAppLoading,
    useSelectorCurrentProductId
} from '../../../app';
import { ErrorView } from '../../../components/error-view/error-view';
import { I18nProvider } from '../../../i18n/i18n-provider';
import { TestLoginRoute } from '../../../routes';
import { useLoadUserProfiles } from '../../../routes/dashboard/hooks';
import { sessionLogout } from '../../../session';
import { useSelectorUserProfiles } from '../../../user-profiles';
import { useUserService } from '../../components/user-service';
import { setAppLoading } from '../app.actions';
import { LoadingState } from '../app.types';
import { useAppInitialization } from './hooks';
import { LoadingView } from '@components';

export const AppInitialization = ({ children }: PropsWithChildren<any>) => {
    const dispatch = useDispatch();
    const {
        isLoading,
        showTestLogin
    } = useAppInitialization();
    const loadingState = useSelectorAppLoading();

    useLayoutEffect(() => {
        const updatedAppLoading = isLoading ? LoadingState.appLoading : LoadingState.loaded;

        dispatch(setAppLoading(updatedAppLoading));
    }, [dispatch, isLoading]);

    if (showTestLogin) return <TestLoginRoute />;
    if (loadingState === LoadingState.appLoading) return <LoadingView />;

    return (
        <ProfileInitialisation>
            <I18nProvider>{children}</I18nProvider>
        </ProfileInitialisation>
    );
};

function ProfileInitialisation ({ children }: PropsWithChildren<any>) {
    const dispatch = useDispatch();

    useLoadUserProfiles();

    const { data: userProfilesData, isError, isLoading } = useSelectorUserProfiles();
    const productId = useSelectorCurrentProductId();
    const setWalkeMeProfile = useUserService();

    // Set user profile data
    useEffect(() => {
        if (userProfilesData && productId) {
            setWalkeMeProfile(userProfilesData, productId);
        }
    }, [userProfilesData, productId, setWalkeMeProfile]);

    useEffect(() => {
        if (isError) {
            dispatch(sessionLogout());
        }
    }, [isError, dispatch]);

    if (isLoading) return <LoadingView />;
    if (isError) return <ErrorView />;

    return <>{children}</>;
}
